import React, { useMemo } from 'react';
import { Avatar, AvatarVariant } from '@avatar/types';
import calculateOptions from './utils';
import ProjectActionMenu, {
  ProjectActionMenuProps,
} from '../../../Projects/ProjectActionMenu';

export interface AvatarOptionsProps extends Pick<ProjectActionMenuProps, 'id'> {
  id: string;
  avatar: Avatar;
  variant?: AvatarVariant;
  onToggleFavorite: () => void;
  onToggleTeamVoice: () => void;
  onSelect: () => void;
  activeAvatarId?: number;
  activeAvatarVariantId?: number;
  sourceIsVoicesPage?: boolean;
  isLoading?: boolean;
  canUpdateTeamVoice: boolean;
}

export enum VoiceGridItemActionLabel {
  StartProject = 'Start a Project',
  SelectAvatar = 'Select this voice',
  Favorite = 'Add to Favorites',
  RemoveFavorite = 'Remove from Favorites',
  AddToTeam = 'Add to Team Voices',
  RemoveFromTeam = 'Remove from Team Voices',
}

const AvatarOptions = ({
  id,
  avatar,
  variant,
  onToggleFavorite,
  onToggleTeamVoice,
  onSelect,
  activeAvatarId,
  activeAvatarVariantId,
  sourceIsVoicesPage,
  isLoading,
  canUpdateTeamVoice,
}: AvatarOptionsProps) => {
  const isFavorited = variant && Boolean(variant.userSettings?.favoritedAt);
  const isTeamVoice = variant && Boolean(variant.teamSettings?.favoritedAt);

  const options = useMemo(
    () =>
      calculateOptions({
        sourceIsVoicesPage,
        avatar,
        variant,
        activeAvatarId,
        activeAvatarVariantId,
        onToggleFavorite,
        onToggleTeamVoice,
        onSelect,
        isFavorited,
        isTeamVoice,
        canUpdateTeamVoice,
      }),
    [
      sourceIsVoicesPage,
      avatar,
      variant,
      activeAvatarId,
      activeAvatarVariantId,
      onToggleFavorite,
      onToggleTeamVoice,
      onSelect,
      isFavorited,
      isTeamVoice,
      canUpdateTeamVoice,
    ]
  );

  return (
    <ProjectActionMenu
      id={`avatar-options-${id}`}
      ariaLabel={'More options'}
      primaryActions={options}
      destructiveActions={[]}
      icon={'moreVert'}
      isLoading={isLoading}
      disableDelayedMenuClose
    />
  );
};

export default AvatarOptions;
